export class LCDQueryClient {
    req;
    constructor({ requestClient }) {
        this.req = requestClient;
        this.params = this.params.bind(this);
        this.getAuthenticators = this.getAuthenticators.bind(this);
    }
    /* Parameters queries the parameters of the module. */
    async params(_params = {}) {
        const endpoint = `osmosis/smartaccount/params`;
        return await this.req.get(endpoint);
    }
    /* GetAuthenticators */
    async getAuthenticators(params) {
        const endpoint = `osmosis/smartaccount/authenticators/${params.account}`;
        return await this.req.get(endpoint);
    }
}
